import React from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

import { ProfileColor, ProfileType, ProfileTypeString } from '../../types/enums/profileType'

interface CreateProfileFromLogModalProps {
  onClose: () => void
  createProfileFromLog: (profileType: ProfileType) => void
  canCreateInletTempProfile?: boolean
}

const CreateProfileFromLogModal = (props: CreateProfileFromLogModalProps): JSX.Element => {
  const { t } = useTranslation()

  const createProfileButton = (profileType: ProfileType): JSX.Element => {
    return (
      <Button
        variant="outlined"
        color={ProfileColor[profileType]}
        onClick={() => props.createProfileFromLog(profileType)}
      >
        {t(ProfileTypeString[profileType])}
      </Button>
    )
  }

  return (
    <Dialog onClose={props.onClose} open={true}>
      <DialogTitle>{t('logview.chooseprofiletype')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {createProfileButton(ProfileType.ET)}
          {createProfileButton(ProfileType.BT)}
          {props.canCreateInletTempProfile && createProfileButton(ProfileType.INLET_TEMP)}
          {createProfileButton(ProfileType.POWER)}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default CreateProfileFromLogModal
